import { TableWidget } from "app/components/widget/widget-types/TableWidget";
import { TableTemplateV2 } from "app/components/widget/dashboard/TableTemplate-v2";
import {
    getTableColumns,
    getManagedTableData,
} from "app/pages/app-intelligence/app-analysis/pages/Engagement/components/helpers";
import { i18nFilter } from "app/filters/i18nFilter";
import { getStoreEngagementVerticals } from "app/pages/app-intelligence/app-analysis/pages/Engagement/Store/StoreEngagementVerticals";
import type { IAppsEngagementTableColumns } from "app/pages/app-intelligence/app-analysis/pages/Engagement/components/types";

export class AppStoreInstallAndDownloadsOverviewTableWidget extends TableWidget {
    static getWidgetMetadataType() {
        return "AppStoreInstallAndDownloadsOverviewTable";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getWidgetDashboardType() {
        return "Table";
    }

    public isPptSupported = () => {
        return false;
    };

    constructor() {
        super();
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }

    protected getMetricColumnsConfig() {
        const appsMetadata: IAppsEngagementTableColumns[] = this.legendItems.map((item) => {
            return {
                Id: item.id,
                Title: item.name,
            };
        });
        return getTableColumns(appsMetadata, true, undefined);
    }

    public reduceRecords(records: any[]): any[] {
        const translate = i18nFilter();
        const managedRecords = getManagedTableData(getStoreEngagementVerticals(), records, translate);
        return managedRecords;
    }
}

AppStoreInstallAndDownloadsOverviewTableWidget.register();
